// extracted by mini-css-extract-plugin
module.exports = {"playerScore":"PlayerCore4ScoreComponent_playerScore__m--3k","score":"PlayerCore4ScoreComponent_score__338_N"};